import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/default-icons.svg")